<template>
  <v-system-bar
                window
                :color="!group?.id ? 'red' : ''"
                class="px-5"
                :height="user.access_level >= $USER_ACCESS_LEVELS_DIC.ADMIN.value || (allGroups && allGroups.length > 1) ? '55px' : '30px'"
                :style="user.access_level >= $USER_ACCESS_LEVELS_DIC.ADMIN.value || (allGroups && allGroups.length > 1) ? 'height: 55px' : 'height: 30px'">
    <img :src="groupIcon" style="width: 30px; height: 30px" />
    <v-icon icon="mdi-account-group" class="mx-2"></v-icon>
    <span v-if="group?.id">[{{ group?.acronym }}] {{ group?.name }}</span>
    <span v-else>NENHUM GRUPO SELECIONADO <span v-if="!allGroups || allGroups.length <= 0" class="font-weight-bold">O
        Usuário logado não é membro de nenhum grupo</span></span>
    <v-spacer></v-spacer>
    <AutocompleteSelectGroup
                             v-if="user.access_level >= $USER_ACCESS_LEVELS_DIC.ADMIN.value"
                             @selected="updatedSelectedGroup"
                             :selected="group"
                             classes="tinyAutocomplete" />
    <v-autocomplete
                    v-else-if="allGroups && allGroups.length > 1"
                    @update:model-value="updatedSelectedGroup"
                    v-model="group"
                    style="max-width: 300px"
                    item-title="name"
                    class="tinyAutocomplete"
                    label="Selecionar Grupo"
                    density="compact"
                    hide-details
                    return-object
                    clearable
                    :items="allGroups">
      <template v-slot:no-data>
        <div class="px-4">Digite sua busca</div>
      </template></v-autocomplete>
  </v-system-bar>
</template>
<script>
import AutocompleteSelectGroup from "./AutocompleteSelectGroup.vue";
import assets from "../assets/assets";
import api from '@/services'
export default {
  components: {
    AutocompleteSelectGroup
  },
  computed: {
    groupIcon() {
      const vm = this;

      if (vm.group?.img) return vm.group?.img;
      return vm.assets.logo;
    }
  },
  props: {
    user: Object,
  },
  data() {
    return {
      assets: assets,
      requestingApi: false,
      group: null,
      allGroups: [],
    };
  },
  created() {
    var vm = this;
    vm.group = api.storage.selectedGroup();
    vm.allUserGroups();
  },
  mounted() { },
  activated() { },
  methods: {
    allUserGroups() {
      var vm = this;
      vm.allGroups = vm.user?.legal_person?.groups || [];
    },
    updatedSelectedGroup(group) {
      var vm = this;
      api.storage.selectGroup(group);
      vm.group = api.storage.selectedGroup();
    },
  },
  watch: {
    user(newVal) {
      this.allUserGroups();
      this.group = api.storage.selectedGroup();
    },
  },
};
</script>